<template>
    <div id="mPanel4" style="height:100%">
        <m-search-list ref="searchList" :advancePrefix="advancePrefix" :configurationUrl="configurationUrl"
                       :list="config.searchList"
                       :longPrefix="longPrefix" :optionNum="optionNum"
                       :popPrefix="popPrefix" :searchId="searchId" :searchSetTitle="searchSetTitle"
                       :searchTotalTitle="searchTotalTitle"
                       @onSearchChange="searchChange" @tableAdvance="tableAdvance">
          <span slot="search-list-advance-right">
              <slot name="search-list-advance-right"></slot>
          </span>
            <div slot="table-module-btn" class="btn-box">
                <slot name="table-module-btn"></slot>
                <el-tooltip v-if="config.configuration?false: true" class="item allocation-box" content="列配置"
                            effect="dark" placement="bottom">
                    <el-button class="el-icon-setting" size="mini" @click="getTitleList"></el-button>
                </el-tooltip>
                <el-dialog :visible.sync="showModal" append-to-body title="列配置" @close="dialogClose">
                    <configuration ref="dialog" :checkedList="checkedList" :columnNum='columnNum'
                                   :selectAllColumns="config.table.columns" @getTableConfigList="getTableConfigList"
                                   @tableConfigClose="tableConfigClose"></configuration>
                </el-dialog>
            </div>
        </m-search-list>
        <div class="all-table">
            <div ref="allTableLeft" class="all-table-left">
                <div ref="lrDragWidth" class="lr-drag" @mousedown.stop.prevent="mousedownLRWidth"></div>
                <div v-if="config.table.seperateTree" class='list-top'>
                    <div class="list-title">{{ sourceTitle }}
                    </div>
                    <ul ref="topLists" class='table-lists'>
                        <el-main v-loading="sourceTreeLoading">
                            <el-scrollbar>
                                <li v-for="(item, index) in sourceRootData" :key="index"
                                    :class="{ 'active': mulSourceSel ? item.isActive : 'source'+index == sourceCurrent}"
                                    class="list-details"
                                    @click="rootListClick(item, 'source', index)">{{ item.textLeft }}
                                </li>
                            </el-scrollbar>
                        </el-main>
                    </ul>
                </div>
            </div>
            <div ref="allTableRight" class="all-table-right">
                <m-table
                    ref="table"
                    :loading="sourceLoading"
                    :longPrefix="longPrefix"
                    :popPrefix="popPrefix"
                    :tableConfig="config.table"
                    :tableData="tableData"
                    :tableList="tableList"
                    :verification="verification"
                    class="source-table"
                    @btnCancleAllocate="cancleAllocateTable"
                    @btnDelete="delTable"
                    @btnEdit="editTable"
                    @btnPrint="printTable"
                    @btnView="checkTable"
                    @moreAction="moreAction"
                    @onCellDblclick="sourceCellDblclick"
                    @onSelectionChange="sourceSelectChange"
                    @select="sourceSelect"
                    @selectAll="sourceSelectAll"
                    @tab-advanced-search="tabAdvancedSearch"
                    @row-db-click="rowDBClick"
                    @save-data="saveData"
                    @switch-change="switchChange"
                    @column-filter-search="columnFilterSearch"
                    @row-click="sourceRowClick"
                >
                    <div slot="expand-table-content" slot-scope="{expandProps}">
                        <slot :expandTable="expandProps" name="expand-table-cont"></slot>
                    </div>
                </m-table>
            </div>
        </div>
        <el-row v-if="!config.transferTables" class="row-bg" justify="space-between" type="flex">
            <el-col :span="12" class="page-text">
                <div v-if="config.table.selectBtn">
                    已选<span class="text-color">&nbsp;&nbsp;{{ checkedNum }}&nbsp;&nbsp;</span>项
                </div>
                <slot name="page-module-btn"></slot>
            </el-col>
            <el-col v-if="!config.transferTables" :span="12">
                <m-page
                    ref="page"
                    :current-page="currentPage"
                    :pageData="pageData"
                    :total="totalData.length"
                    @on-page-change="pageChange"
                    @on-size-change="sizeChange"
                ></m-page>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import mSearchList from '../../../../../../components/mulitPanel/mSearchList';
import mTable from '@/components/otpPanel/mTable';
import mPage from '@/components/awesome/page/mPanel3/mPage';
import configuration from '@/components/awesome/page/mPanel3/configuration-list';
import getList from '@/components/awesome/page/mPanel3/api';
import { mapGetters } from 'vuex';

export default {
    name: 'mPanel',
    components: { mTable, mSearchList, mPage, configuration },
    props: {
        config: Object,
        totalData: Array,
        sourceRootData: Array,
        sourceTitle: String,
        pageID: String,
        searchId: String,
        optionNum: String,
        loading: {
            type: Boolean,
            default() {
                return true;
            }
        },
        verification: {
            type: Object,
            default() {
                return {};
            }
        },
        method: {
            type: String,
            default: 'get'
        },
        searchTotalTitle: {
            type: Array,
            default() {
                return [];
            }
        },
        searchSetTitle: {
            type: Array,
            default() {
                return [];
            }
        },
        endMoveHeight: {
            type: Number,
            default() {
                return 0;
            }
        },
        columnNum: Number,
        mulSourceSel: Boolean,
        isRefreshTarget: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isCondition: false,
            isShowImg: true,
            input: '',
            sourceCurrent: '',
            targetCurrent: '',
            checkedNum: 0,
            startMove: 0,
            endMoveWidth: 0,
            endListMoveHeight: 0,
            showModal: false,
            tableList: '',
            settingColumns: this.config.table.columns,
            checkedList: '',
            pageState: true,
            popPrefix: this.config.popPrefix ? this.config.popPrefix : '/api-mdm/dictionaryDetail/dict',
            advancePrefix: this.config.advancePrefix ? this.config.advancePrefix : '/api-mdm',
            longPrefix: this.config.longPrefix ? this.config.longPrefix : '/api-gwms/es/comboBox',
            configurationUrl: this.config.configurationUrl ? this.config.configurationUrl : '/api-auth',
            resourceCode: '',
            sourceLoading: false,
            sourceTreeLoading: false,
            // 分页 - 分页信息
            pageData: this.config.page,
            // 分页 - 当前页
            currentPage: 0
        };
    },
    computed: {
        ...mapGetters(['menus']),
        tableData() {
            const s = this.pageData.pageSize;
            const i = Math.max(this.currentPage - 1, 0);
            return this.totalData.slice(s * i, s * (i + 1));
        }
    },
    watch: {
        totalData(newVal, oldVal) {
            const s = this.pageData.pageSize;
            const i = Math.max(this.currentPage - 1, 0);
            if (s * i > newVal.length) {
                this.currentPage = Math.floor(newVal.length / s);
            }
        }
    },
    mounted() {
        this.$refs.allTableLeft.style.width = '198px';
        this.getTableTitle().then(() => {
            this.initTitleList();
        });
    },
    methods: {
        deepMenu(node) {
            const pageRoutePath = '/otp/dispatch-Manage/train-list';
            const nodes = [];
            if (node) {
                nodes.push(node);
                const childrens = node.subResources;
                if (childrens) {
                    for (let i = 0; i < childrens.length; i++) {
                        if (childrens[i].frontUrl === pageRoutePath) {
                            this.resourceCode = childrens[i].resourceCode;
                        } else {
                            this.deepMenu(childrens[i]);
                        }
                    }
                }
            }
        },
        showInput() {
            this.isShowImg = false;
            this.isCondition = true;
        },
        // 漏斗切换搜索事件
        searchInput(ev, isClick) { // isClick 用于调度中心 activated 钩子
            this.$emit('search-input', this.input, ev, isClick);
        },
        // 表格中按钮触发事件
        checkTable(data) {
            this.$emit('check-btn', data);
        },
        editTable(data) {
            this.$emit('edit-btn', data);
        },
        printTable(data) {
            this.$emit('print-btn', data);
        },
        delTable(data) {
            this.$emit('del-btn', data);
        },
        cancleAllocateTable(data) {
            this.$emit('cancleAllocate-btn', data);
        },
        saveData(data) {
            this.$emit('saveData', data);
        },
        // 表单选项变化
        sourceSelectChange(data) {
            this.$emit('source-select-change', data);
            this.checkedNum = data.length;
        },
        targetSelectChange(data) {
            this.$emit('target-select-change', data);
            this.checkedNum = data.length;
        },
        switchChange(data) {
            this.$emit('switch-change', data);
            //  表格内switch切换
        },
        rowDBClick(row) {
            this.$emit('row-db-click', row);
        },
        // 搜索内容变化
        searchChange(data) {
            this.$emit('searchChange', data);
        },
        // 分页器改变触发事件
        pageChange(currentPage) {
            this.currentPage = currentPage;
            this.$emit('pageChange', currentPage);
        },
        sizeChange(size) {
            this.pageData.pageSize = size;
            this.$emit('sizeChange', size);
        },
        getTableConfigList(tabelConfigList, tabelConfigName) {
            if (this.config.configuration) {
            } else {
                this.showModal = false;
                const pramas = {
                    'configName': tabelConfigName,
                    'configNameCn': tabelConfigList,
                    'subjectType': this.pageID,
                    'moduleCode': this.resourceCode
                };
                getList.post(this.configurationUrl, pramas).then(() => {
                });
                this.tableList = tabelConfigList;
            }
        },
        tableConfigClose() {
            this.showModal = false;
        },
        dialogClose() {
            this.$refs.dialog.initData();
        },
        // 获取表格头保存参数
        async getTableTitle() {
            if (this.config.configuration) {
                return new Promise((resolve) => {
                    resolve(() => {
                        this.checkedList = '';
                    });
                });
            } else {
                const menu = { subResources: JSON.parse(JSON.stringify(this.menus)) };
                await this.deepMenu(menu);
                let allColumns = [];
                let allColumnsprop = [];
                this.config.table.columns.map((item, index) => {
                    if (this.columnNum && index >= this.columnNum) {
                    } else {
                        allColumns.push(item.label);
                        allColumnsprop.push(item.prop);
                    }
                });
                allColumns = allColumns.join(',');
                allColumnsprop = allColumnsprop.join(',');
                const pramas = {
                    'configName': allColumnsprop,
                    'configNameCn': allColumns,
                    'moduleCode': this.resourceCode,
                    'subjectType': this.pageID
                };
                return getList.get(this.configurationUrl, pramas).then(data => {
                    if (data.data) {
                        this.checkedList = data.data.configNameCn;
                    } else {
                        this.checkedList = allColumns;
                    }
                }).catch(() => {
                    this.checkedList = allColumns;
                });
            }
        },
        initTitleList() {
            let laberString = [];
            if (this.checkedList === '') {
                this.config.table.columns.map(data => {
                    laberString.push(data.label);
                });
                laberString = laberString.join(',');
                this.tableList = laberString;
            } else {
                this.tableList = this.checkedList;
            }
        },
        getTitleList() {
            return this.getTableTitle().then(() => {
                this.showModal = true;
            });
        },
        // 表格内高级搜索
        tabAdvancedSearch(data, item, type, searchData) {
            this.$refs.searchList.detaliSearch(data, item, type, searchData);
        },
        tableAdvance(prop, advanceCode, data, code) {
            this.$refs.table.ruleForm[prop] = data;
            this.$refs.table.ruleForm[advanceCode] = code;
        },
        columnFilterSearch(data) {
            this.$refs.searchList.onSearchChange(data);
        },
        statusChange(status) {
            this.$refs.table.changeStatu(status);
        },
        changeLoading(status) {
            this.$refs.searchList.changeLoading(status);
        },
        moreAction(selection, index) {
            this.$emit('moreAction', selection, index);
        },
        rootListClick(item, to, index) {
            this.$emit('root-click', item, to);
            if (to === 'source') {
                this.sourceCurrent = to + index;
            } else if (to === 'target') {
                this.targetCurrent = to + index;
            }
        },
        toVisualDispatchCenter() {
            this.$emit('toVisualDispatchCenter');
        },
        targetTableEndMove(moveHeight) {
            const targetTabelEl = document.getElementById('mPanel4').getElementsByClassName('source-table');
            const targetTabelE2 = document.getElementById('mPanel4').getElementsByClassName('table-header');
            targetTabelEl[0].style.height = `calc((100% - 50px)/2 - ${this.endMoveHeight}px - ${moveHeight}px)`;
            targetTabelE2[0].style.height = `calc((100% - 50px)/2 + ${this.endMoveHeight}px + ${moveHeight}px)`;
        },
        mousedownLRWidth(e) {
            this.startMove = e.clientX;
            var distance = 0;
            document.onmousemove = (ev) => {
                var thisEvent = ev || event;
                distance = this.startMove - thisEvent.clientX;
                if (distance + this.endMoveWidth >= 100) {
                    distance = 0;
                    this.endMoveWidth = 100;
                    return;
                }
                if (distance + this.endMoveWidth <= -20) {
                    distance = 0;
                    this.endMoveWidth = -20;
                    return;
                }
                this.$refs.allTableLeft.style.width = `calc(198px - ${this.endMoveWidth}px - ${distance}px)`;
                this.$refs.allTableRight.style.width = `calc(100% - ${this.$refs.allTableLeft.style.width})`;
            };
            document.onmouseup = () => {
                document.onmousemove = null;
                document.onmouseup = null;
                this.endMoveWidth = this.endMoveWidth + distance;
            };
        },
        initActiveChange() {
            this.sourceCurrent = '';
            this.targetCurrent = '';
            this.input = '';
        },
        sourceCellDblclick(row, column, cell, event) {
            this.$emit('sourceCellDblclick', row, column, cell, event);
        },
        sourceRowClick(row) {
            this.$emit('sourceRowClick', row);
        },
        sourceSelect(selection, row) {
            this.$emit('sourceSelect', selection, row);
        },
        sourceSelectAll(selection) {
            this.$emit('sourceSelectAll', selection);
        }
    }
};
</script>
<style lang="less">
@import './mpanel.less';
</style>
